export const formatRupiah = (amount) => {
    return new Intl.NumberFormat('id-ID', {
        style: 'currency',
        currency: 'IDR',
        minimumFractionDigits: 0, // No decimal places
        maximumFractionDigits: 0, // No decimal places
    }).format(amount || 0);
};